// Import the functions you need from the SDKs you need
import {initializeApp} from 'firebase/app'
import { getFirestore } from 'firebase/firestore';
import { collection } from 'firebase/firestore';


// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyC-knmBe8Fn-tAOv-gORlamuEwJ-nHJF6I",
  authDomain: "portfolio-31d36.firebaseapp.com",
  databaseURL: "https://portfolio-31d36-default-rtdb.firebaseio.com",
  projectId: "portfolio-31d36",
  storageBucket: "portfolio-31d36.appspot.com",
  messagingSenderId: "868317280735",
  appId: "1:868317280735:web:f9d533de84b0fe9e17ec6a"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);
const firestore = getFirestore(app);

export default firestore;
// import firebase from 'firebase/app';
// import 'firebase/firestore';

// const firebaseConfig = {
//   apiKey: 'AIzaSyC-knmBe8Fn-tAOv-gORlamuEwJ-nHJF6I',
//   authDomain: 'portfolio-31d36.firebaseapp.com',
//   projectId: 'portfolio-31d36',
//   storageBucket: 'portfolio-31d36.appspot.com',
//   messagingSenderId: "868317280735",
//   appId: "1:868317280735:web:f9d533de84b0fe9e17ec6a"
// };

// firebase.initializeApp(firebaseConfig);
// const firestore = firebase.firestore();

// export default firestore;

